// @flow

import * as React from 'react';

import { globalize, localize, unescaped } from '@ta/common.i18n';

import styles from './EventDate.less';

type Props = {
  stayDate: string,
  placeType: string,
};

const eventDateTranslations = (placeType: string, params: any) => {
  switch (placeType) {
    case 'ACCOMMODATION':
      return localize('Date_of_stay', params); /* localize('Date_of_stay') Date of stay: */

    case 'AIRLINE':
      return localize('Date_of_travel', params); /* localize('Date_of_travel') Date of travel: */

    case 'ACTIVITY':
    case 'ATTRACTION':
      return localize(
        'Date_of_experience',
        params,
      ); /* localize('Date_of_experience') Date of experience: */

    case 'EATERY':
      return localize('Date_of_visit', params); /* localize('Date_of_visit') Date of visit: */
    case 'SHIP':
      return localize(
        'cruise_review_sail_date',
        params,
      ); /* localize('cruise_review_sail_date') Sail Date: */

    default:
      break;
  }

  return '';
};

const EventDate = ({ stayDate, placeType }: Props) => {
  if (stayDate) {
    const messageParams = {
      '0': styles.bold,
      '1': globalize.formatDate('date_full_month_year', new Date(stayDate)), // January, 2018
    };
    const message = eventDateTranslations(placeType, messageParams);

    return <div className={styles.event_date}>{unescaped(message)}</div>;
  }

  return null;
};

export default EventDate;
